import { render, staticRenderFns } from "./PriceChartContinuous.vue?vue&type=template&id=71fca966"
import script from "./PriceChartContinuous.vue?vue&type=script&lang=js"
export * from "./PriceChartContinuous.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports